import ProductReviews from "./ProductReviews.component";

export default ProductReviews;
